module.exports = __webpack_public_path__ + "img/kiesreis_logo.b8ff4232.png";